import { toggleScrollLock } from 'common/utils';
import Cookie from 'js-cookie';

const countrySelector = document.getElementById('country-selector');
const countrySelectorStayOnUS = document.getElementById('country-selector-us');
const scrollLockSelector = '#country-selector .Modal__content';
countrySelector && toggleScrollLock(scrollLockSelector, true);

countrySelectorStayOnUS &&
  countrySelectorStayOnUS.addEventListener('click', e => {
    e && e.preventDefault();
    toggleScrollLock(scrollLockSelector, false);
    Cookie.set('stayOnJUULUS', true);
    countrySelector.remove();
  });



// WEBPACK FOOTER //
// ./app/javascript/apps/application/country-selector.js